module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/spinner/spinner.component.scss
// module id = ./src/app/shared/components/spinner/spinner.component.scss
// module chunks = main